/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/images/pokedex/svelte-structure.png",
        "alt": "Estructura de archivos de Svelte"
      }}></img></p>
    <p>{`En `}<inlineCode parentName="p">{`public`}</inlineCode>{` además del `}<inlineCode parentName="p">{`favicon.ico`}</inlineCode>{` y nuestro `}<inlineCode parentName="p">{`HTML`}</inlineCode>{` base también debemos colocar nuestros archivos estáticos como imágenes, logos e iconos para que sean utilizados por Svelte.`}</p>
    <p>{`Svelte tambien nos da un archivo `}<inlineCode parentName="p">{`global.css`}</inlineCode>{` para nuestros estilos globales.`}</p>
    <p>{`Otra gran diferencia es que utiliza `}<em parentName="p">{`rollup`}</em>{` para crear el servidor de desarrollo y el build de producción, el resto utiliza webpack.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;